<template>
  <aside class="aside-menu d-lg-none" :class="{ 'aside-menu-active': menuOpen }">
    <div class="aside-menu-itens">
      <div class="menu-header">
        <div class="aside-menu-itens-header">
          <div class="content-menu">
            <a class="content-menu-item btn-menu" @click="setMenuOpen(false)">
              <!-- <span class="active"></span> -->
              <img src="@/assets/img/round-arrow-right.png" alt="arrow menu" />
            </a>
          </div>
        </div>
        <div class="content-buttons">
          <button class="btn-login">
            <div>
              <img src="@/assets/img/user.png" alt="user icon" width="22" height="24">
            </div>
            <template v-if="userIsLogged">
              <div @click="goToAccount(); setMenuOpen(false)">
                <p>{{ this.user.nome.substring(0, 8) + '...' }}</p>
              </div>
            </template>
            <template v-else>
              <div @click="setMenuOpen(false)">
                <p>entrar</p>
              </div>
            </template>
          </button>
          <!-- <template v-if="userIsLogged">
            <router-link tag="a" :to="{name: 'MyAccount'}" @click.native="setMenuOpen(false)" class="content-name-user">
              <p>Bem vindo <span>{{ user.name }} {{ user.last_name }}</span></p>
            </router-link>
            <router-link tag="a" :to="{name: 'MyAccount'}" @click.native="setMenuOpen(false)" class="btn-login">
              <p>A sua conta</p>
            </router-link>
            <button @click="logoff(); setMenuOpen(false)" class="btn-login">
              <p>Terminar sessão</p>
            </button>
          </template>
          <template v-else>
            <router-link tag="a" :to="{name: 'PartnersInfo'}" @click.native="setMenuOpen(false)" class="btn-partners">
              <p>Parceiros</p>
            </router-link>
            <router-link tag="a" :to="{name: 'Login'}" @click.native="setMenuOpen(false)" class="btn-login">
              <p>Iniciar sessão</p>
            </router-link>
          </template> -->
        </div>
        <div class="aside-menu-itens-links">
          <router-link tag="a" :to="{name: 'Home'}" @click.native="setMenuOpen(false)" class="links"> 
            <p>Início</p>
          </router-link>
          <router-link tag="a" :to="{name: 'Prizes'}" @click.native="setMenuOpen(false)" class="links"> 
            <p>prémios</p>
          </router-link>
          <router-link tag="a" :to="{name: 'Faqs'}" @click.native="setMenuOpen(false)" class="links"> 
            <p>perguntas frequentes</p>
          </router-link>
        </div>
      </div>
      <div class="menu-footer">
        <div class="menu-footer-links">
          <a href="/storage/app/media/informacoeslegais/politicadeprivacidade.pdf" target="_blank" rel="noopener" @click.native="setMenuOpen(false)" class="links"> 
            <p>Política de Privacidade</p>
          </a>
          <router-link tag="a" :to="{name: 'Home'}" @click.native="goToPage('termos-e-condicoes-web'); setMenuOpen(false)" class="links"> 
            <p>Termos e condições de utilização</p>
          </router-link>
        </div>
        <div class="menu-footer-logo">
          <img src="@/assets/img/footer/logos.png" alt="logo">
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Menu", 
  data() {
    return {
      activeChat: false,
    };
  },
  computed: {
    ...mapGetters(["menuOpen", 'userIsLogged', 'user']),
  },
  methods: {
     ...mapActions({
      setMenuOpen: "setMenuOpen",
    }),
    goToPage(slug) {
        this.$router.push({ name: "LegalInformation", params: { slug: slug } });
        if (this.$route.name == "LegalInformation") {
            this.$router.go();
        }
    },
    
   // ...mapActions("User", ["accountLogout"]),
  //   logoff(){
	// 		this.accountLogout()
  //     .then(() => {
  //       this.$router.push('/');
  //     }).catch((error) => {
  //       console.log(error);
  //     });
	// 	},
  // },
  // accountLogout() {
  //   this.logout();
  //   this.setMenuOpen(false);
  goToAccount(){
    this.$router.push('/account');
  },
  },
};
</script>

<style lang="scss">
.aside-menu {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 90%;
  height: 100%;
  background: var(--main-color);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition: 0.8s ease-in-out;
  right: -100%;
  pointer-events: none;
  z-index: 1030;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  @media (max-width: 359px){
    width: 100%;
  }
  &-active {
    right: 0;
    pointer-events: initial;
  }
  &-itens {
    display: flex;
    flex-direction: column;
    align-content: flex-end;
    align-items: flex-end;
    justify-content: space-between;
    margin: 55px 25px 0 0;
    &-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 15px 30px;
      width: 100%;
      img {
        max-width: 120px;
      }
      .content-menu {
        display: flex !important;;
        justify-content: flex-end!important;
        &-item {
          width: 47px;
          height: 45px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          text-decoration: none !important;
          border: 1px solid var( --green-medium);
          border-radius: 10px;
          padding-top: 0;
          span {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 0;
            &::before, &::after {
              width: 20px
            }
          }
        }
      }
    }
    &-links {
      width: 100%;
      a {
        display: block;
        font-family: "Font Regular";
        color: var( --white) !important;
        font-size: 20px;
        margin-bottom: 0;
        width: 100%;
        padding: 15px 30px;
        transition: 500ms;
        text-decoration: none;
        text-align: left;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }
      }
      .links {
        display: flex;
        align-items: flex-end;
        p {
          width: 100%;
          font-family: "Font Bold";
          color: var( --white) !important;
          font-size: 18px;
          margin-bottom: 0;
          text-align: right;
          text-transform: uppercase;
        }
        &-icon {
          height: 56px;
          width: 56px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: var(--main-color2);
          border-radius: 100%;
          margin-left: 10px;
          svg {
            fill: var(--white);
            max-width: 30px;
          }
        }
      }
    }
    .card {
      border: 0;
      background: 0;
      border-radius: 0px;
      &-header {
        border: 0;
        background: 0;
        border-radius: 0px;
        padding: 0;
      }
      .btn-link {
        padding: 15px;
        padding-bottom: 0px;
        font-size: 20px;
        color: var( --green-dark);
        font-family: "Font Bold";
        border: 0;
        width: 100%;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-shadow: none;
        & > div {
          transition: 500ms;
          margin-left: 10px;
          svg {
            fill: var( --green-medium);
            transition: 500ms;
          }
        }
      }
      [aria-expanded="true"] {
        opacity: 0.8;
        & > div {
          transform: rotate(180deg);
        }
      }
      &-body {
        padding: 0;
        &-links {
          display: flex;
          align-items: center;
          height: 40px;
          width: 100%;
          padding-left: 30px;
          color: var( --green-dark);
          font-size: 14px !important;
          letter-spacing: 1.5px;
          font-family: "Font Light";
          transition: 500ms;
          &:hover,
          &:focus {
            cursor: pointer;
          }
        }
      }
    }
    &-collapse {
      &-btn {
        font-family: "Font Regular";
        color: var( --green-dark) !important;
        background: 0;
        border: 0;
        font-size: 20px;
        display: block;
        width: 100%;
        padding: 15px;
        transition: 500ms;
        text-align: left;
        display: flex;
        align-items: center;
        p{
          padding-bottom: 0;
          margin-bottom: 0;
          font-size: 18px;
          font-family: "Font Regular", sans-serif;
          color: var( --green-medium);
          span{
            font-size: 18px;
            font-family: "Font Regular", sans-serif;
            color: var( --green-dark);
          }
        }
    
        & > div {
          transition: 500ms;
          margin-left: 7px;
          svg {
            fill: var( --green-medium);
            transition: 500ms;
          }
        }
        &[aria-expanded="true"] {
          opacity: 0.8;
          & > div {
            transform: rotate(180deg);
          }
        }
      }
    }
    .content-name-user {
      display: block;
      text-align: right;
      padding: 15px 30px;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.8;
      }
      p {
        font-size: 20px;
        font-family: 'Font Regular';
        color: #878787;
        line-height: 1.2;
        max-width: 100%;
        margin-bottom: 0;
        span {
          display: block;
          font-family: 'Font Bold';
          color: var( --green-medium);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .btn-partners {
      width: 156px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--white);
      border: 1px solid var(--gray);
      border-radius: 10px;
      margin: 15px 30px;
      transition: 500ms;
      box-shadow: 5px 5px 10px rgba(0,0,0,0.16);
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.6;
      }
      p {
        font-size: 22px;
        font-family: 'Font Regular';
        color: var(--gray);
        margin-bottom: 0;
      }
    }
    .btn-login {
      width: 232px;
      height: 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: var(--white);
      border: 1px solid var(--gray);
      border-radius: 28px;
      margin: 15px 30px;
      padding: 0 35px;
      transition: 500ms;
      box-shadow: 5px 5px 10px rgba(0,0,0,0.16);
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.6;
      }
      p {
        font-size: 18px;
        font-family: 'Font Bold';
        color: black;
        margin-bottom: 0;
        text-transform: uppercase;
      }
    }
  }
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
  .btn-logout{
    all: unset;
    color: #878787;
    margin-top: 10px;
  }
  .account{
    text-decoration: none;
    color: #878787;
  }
}
.dropdown:hover .dropdown-content {
  display: block;
}
.content-buttons{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 30px;
}
.menu-header{
  height: 400px;
}
.menu-footer{
  margin: 50px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 30px;
  height: 352px;
  &-links{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 30px;
    width: 100%;
    p{
      font-size: 12px;
      font-family: 'Font Bold';
      color: var(--white);
      line-height: 19px;
      margin-bottom: 0;
      text-align: right;
      text-transform: uppercase;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
  &-logo{
    img{
      width: 100%;
      height: auto;
    }
  }
}
</style>